import dayjs from 'dayjs';

import type { SubscriptionPaymentMethod } from 'utils/types/Subscription';

export interface SubscriptionPaymentDetails {
  paymentMethod: SubscriptionPaymentMethod;
  mercadoPagoPaymentId: string;
  paidAt: string;
  renewalDueAt: string;
}

/** Próximo ciclo de cobrança/lembrete (assinatura mensal). */
export const computeRenewalDueAt = (
  paidAt: dayjs.Dayjs = dayjs(),
): string => paidAt.add(1, 'month').toISOString();

export const buildSubscriptionPaymentDetails = (
  paymentMethod: SubscriptionPaymentMethod,
  mercadoPagoPaymentId: string,
): SubscriptionPaymentDetails => {
  const paidAt = dayjs();
  return {
    paymentMethod,
    mercadoPagoPaymentId: String(mercadoPagoPaymentId),
    paidAt: paidAt.toISOString(),
    renewalDueAt: computeRenewalDueAt(paidAt),
  };
};

/** ID usado em preapprovalId para assinaturas pagas via PIX (pagamento avulso). */
export const buildPixPreapprovalId = (paymentId: string | number): string =>
  `pix-${paymentId}`;
